import { Expose } from "class-transformer";

export class CreateUserHasQualificationHasFileDto {
  @Expose()
  userHasQualificationId: string;

  @Expose()
  fileId: string;
}
